import {
    Button,
    CircularProgress,
    InputBase,
    Grid,
    Paper,
    TextField,
} from '@mui/material';
import Typography, { typographyClasses } from '@mui/material/Typography';
import { styled } from '@mui/material/styles'

import clsx from 'clsx';
import qs from 'qs';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ROUTEHOME } from '../../routes';
import { OAuthToken } from '../../types';
import { AppState } from 'src/store';
import Header from '../components/Header';
import {
    addSnackbar,
    changePage,
    changePageTitle,
    setLoginSuccess
} from '../../actions';
import * as routes from '../../routes';

const ForgotPasswordLink = styled(Typography)(({ theme }) => ({
    [`&.${typographyClasses.root}`]: {
        color: theme.palette.primary.main,
        cursor: 'pointer',
        [`:hover`]: {
            textDecoration: 'underline'
        },
    }
}));

const Login: React.FC = () => {
    const dispatch = useDispatch();
    const [username, setUsername] = useState(''); // 'root'
    const [password, setPassword] = useState(''); // 'root'

    const apiEndpoint = useSelector((state: AppState) => state.global.options.baseUrl);

    useEffect(() => {
        dispatch(changePageTitle('Login'))
    }, []);

    const signUp = (event: React.SyntheticEvent | React.MouseEvent) => {
        event.preventDefault();
        dispatch(changePage(routes.ROUTESIGNUP));
    };

    const resetPass = (event: React.SyntheticEvent | React.MouseEvent) => {
        event.preventDefault();
        dispatch(changePage(routes.ROUTEREQUESTRESETPASSWORD));
    };

    const verifyCredentials = async () => {
        let endpoint = apiEndpoint + '/token';
        let body = {
            grant_type: 'password',
            username: username,
            password: password,
        };
        let options: RequestInit = {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: qs.stringify(body),
        };

        try {
            let response = await fetch(endpoint, options)
            if (response.status === 200) {
                const token: OAuthToken = (await response.json()) as OAuthToken
                dispatch(addSnackbar('Login successful!', 'loginSuccess', {}))
                setTimeout(() => {
                    dispatch(setLoginSuccess(token));
                    dispatch(changePage(ROUTEHOME));
                }, 1);
            } else {
                let text = await response.text()
                const data = JSON.parse(text)
            }
        } catch (err) {
            dispatch(addSnackbar('Login error!', 'loginError', {}))
        }

    }

    return (<>
        <Header />
        <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            sx={{ minHeight: '100vh', backgroundColor: theme => theme.palette.grey[300] }}
        >

            <Grid size={3}>


                <Paper sx={{ p: 1 }}>

                    <Grid
                        container
                        direction='column'
                        justifyContent='space-around'
                        spacing={1}
                    >

                        <Grid>
                            <TextField
                                size='small'
                                label={'email'}
                                fullWidth
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                            />
                        </Grid>

                        <Grid>
                            <TextField
                                size='small'
                                label={'password'}
                                fullWidth
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                inputProps={{
                                    type: 'password'
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        verifyCredentials()
                                    }
                                }}
                            />
                        </Grid>

                        <Grid>
                            <Grid
                                container
                                direction='row'
                                alignItems='center'
                                justifyContent='space-around'
                            >
                                <Grid>
                                    <Button variant='outlined' size="small" onClick={signUp}>{'Sign Up'}</Button>
                                </Grid>

                                <Grid>
                                    <Button variant='contained' size="small" onClick={verifyCredentials}>{'Login'}</Button>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid>
                            <Grid
                                container
                                direction='row'
                                alignItems='center'
                                justifyContent='space-around'
                            >
                                <Grid>
                                    <ForgotPasswordLink
                                        variant={'subtitle2'}
                                        onClick={resetPass}
                                    >{'Forgot password?'}</ForgotPasswordLink>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </Grid>
    </>)
}

export default Login
